// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {translate} from '../../../shared/services/translation-service';

const ValidationAndVsrErrorMessages = props =>

    <div>

        {props.isValid ?
            null :
            <span className='error-message'>
                <FormattedMessage id={props.errorMessage}/>
            </span>
        }
        {props.vsrMessage &&
            <span className='vsr-message'>{`${props.vsrMessage} (${translate('SAVE_TO_VALIDATE')})`}</span>
        }
    </div>;

ValidationAndVsrErrorMessages.displayName = 'ValidationAndVsrErrorMessages';
ValidationAndVsrErrorMessages.propTypes = {
    errorMessage: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired,
    vsrMessage: PropTypes.string
};

export default ValidationAndVsrErrorMessages;




// WEBPACK FOOTER //
// ./src/claim/shared/components/validation-and-vsr-error-messages.js